import { Pipe, PipeTransform } from '@angular/core'

@Pipe({ name: 'nl2br' })
export class Nl2brPipe implements PipeTransform {
    transform(input: any): string {
        if (!input || typeof input !== 'string') {
            return input
        }

        return input.replace(/\n/g, '<br>')
    }
}
